import { render, staticRenderFns } from "./_.vue?vue&type=template&id=12d0cec0&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
import style0 from "./_.vue?vue&type=style&index=0&id=12d0cec0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0cec0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksContainer: require('/app/components/blocks/BlocksContainer.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
